import { KycCountries } from '../../types/KycTypes';

/**
 * Full, per-country-translated citizenship country lists, captured from the real
 * know-your-customer-service v4 `get_survey` response (LP-2995) -- the real `kycCountries` field is not
 * the short SE/NO/DK/FI/DE list this file used to guess at, it's the whole selectable country list,
 * translated into that market's language.
 */
export const KYC_COUNTRIES_NO: KycCountries[] = [
    { id: 'se', label: 'Sverige' },
    { id: 'no', label: 'Norge' },
    { id: 'dk', label: 'Danmark' },
    { id: 'fi', label: 'Finland' },
    { id: 'af', label: 'Afghanistan' },
    { id: 'al', label: 'Albania' },
    { id: 'dz', label: 'Algerie' },
    { id: 'vi', label: 'De amerikanske jomfruøyene' },
    { id: 'as', label: 'Amerikansk Samoa' },
    { id: 'ad', label: 'Andorra' },
    { id: 'ao', label: 'Angola' },
    { id: 'ai', label: 'Anguilla' },
    { id: 'aq', label: 'Antarktis' },
    { id: 'ag', label: 'Antigua og Barbuda' },
    { id: 'ar', label: 'Argentina' },
    { id: 'am', label: 'Armenia' },
    { id: 'aw', label: 'Aruba' },
    { id: 'au', label: 'Australia' },
    { id: 'az', label: 'Aserbajdsjan' },
    { id: 'bs', label: 'Bahamas' },
    { id: 'bh', label: 'Bahrain' },
    { id: 'bd', label: 'Bangladesh' },
    { id: 'bb', label: 'Barbados' },
    { id: 'by', label: 'Belarus' },
    { id: 'be', label: 'Belgia' },
    { id: 'bz', label: 'Belize' },
    { id: 'bj', label: 'Benin' },
    { id: 'bm', label: 'Bermuda' },
    { id: 'bt', label: 'Bhutan' },
    { id: 'bo', label: 'Bolivia' },
    { id: 'bq', label: 'Bonaire, Sint Eustatius og Saba' },
    { id: 'ba', label: 'Bosnia-Hercegovina' },
    { id: 'bw', label: 'Botswana' },
    { id: 'bv', label: 'Bouvetøya' },
    { id: 'br', label: 'Brasil' },
    { id: 'vg', label: 'De britiske jomfruøyene' },
    { id: 'io', label: 'Det britiske territoriet i Indiahavet' },
    { id: 'bn', label: 'Brunei' },
    { id: 'bg', label: 'Bulgaria' },
    { id: 'bf', label: 'Burkina Faso' },
    { id: 'bi', label: 'Burundi' },
    { id: 'ky', label: 'Caymanøyene' },
    { id: 'cf', label: 'Den sentralafrikanske republikk' },
    { id: 'cl', label: 'Chile' },
    { id: 'co', label: 'Colombia' },
    { id: 'ck', label: 'Cookøyene' },
    { id: 'cr', label: 'Costa Rica' },
    { id: 'cw', label: 'Curaçao' },
    { id: 'cy', label: 'Kypros' },
    { id: 'dj', label: 'Djibouti' },
    { id: 'dm', label: 'Dominica' },
    { id: 'do', label: 'Den dominikanske republikk' },
    { id: 'ec', label: 'Ecuador' },
    { id: 'eg', label: 'Egypt' },
    { id: 'gq', label: 'Ekvatorial-Guinea' },
    { id: 'ci', label: 'Elfenbenskysten' },
    { id: 'sv', label: 'El Salvador' },
    { id: 'er', label: 'Eritrea' },
    { id: 'ee', label: 'Estland' },
    { id: 'et', label: 'Etiopia' },
    { id: 'fk', label: 'Falklandsøyene' },
    { id: 'fj', label: 'Fiji' },
    { id: 'ph', label: 'Filippinene' },
    { id: 'ae', label: 'De forente arabiske emirater' },
    { id: 'fr', label: 'Frankrike' },
    { id: 'gf', label: 'Fransk Guyana' },
    { id: 'pf', label: 'Fransk Polynesia' },
    { id: 'tf', label: 'De franske sørterritorier' },
    { id: 'ga', label: 'Gabon' },
    { id: 'gm', label: 'Gambia' },
    { id: 'ge', label: 'Georgia' },
    { id: 'gh', label: 'Ghana' },
    { id: 'gi', label: 'Gibraltar' },
    { id: 'gr', label: 'Hellas' },
    { id: 'gd', label: 'Grenada' },
    { id: 'gp', label: 'Guadeloupe' },
    { id: 'gu', label: 'Guam' },
    { id: 'gt', label: 'Guatemala' },
    { id: 'gg', label: 'Guernsey' },
    { id: 'gn', label: 'Guinea' },
    { id: 'gw', label: 'Guinea-Bissau' },
    { id: 'gy', label: 'Guyana' },
    { id: 'ht', label: 'Haiti' },
    { id: 'hm', label: 'Heard- og McDonaldøyene' },
    { id: 'hn', label: 'Honduras' },
    { id: 'hk', label: 'Hongkong' },
    { id: 'in', label: 'India' },
    { id: 'id', label: 'Indonesia' },
    { id: 'iq', label: 'Irak' },
    { id: 'ir', label: 'Iran' },
    { id: 'ie', label: 'Irland' },
    { id: 'is', label: 'Island' },
    { id: 'im', label: 'Man' },
    { id: 'il', label: 'Israel' },
    { id: 'it', label: 'Italia' },
    { id: 'jm', label: 'Jamaica' },
    { id: 'jp', label: 'Japan' },
    { id: 'ye', label: 'Jemen' },
    { id: 'je', label: 'Jersey' },
    { id: 'jo', label: 'Jordan' },
    { id: 'cx', label: 'Juleøya' },
    { id: 'kh', label: 'Kambodsja' },
    { id: 'cm', label: 'Kamerun' },
    { id: 'ca', label: 'Canada' },
    { id: 'cv', label: 'Kapp Verde' },
    { id: 'kz', label: 'Kasakhstan' },
    { id: 'ke', label: 'Kenya' },
    { id: 'cn', label: 'Kina' },
    { id: 'kg', label: 'Kirgisistan' },
    { id: 'ki', label: 'Kiribati' },
    { id: 'cc', label: 'Kokosøyene' },
    { id: 'km', label: 'Komorene' },
    { id: 'cg', label: 'Kongo - Republikken' },
    { id: 'cd', label: 'Kongo - Den demokratiske republikken' },
    { id: 'xk', label: 'Kosovo' },
    { id: 'hr', label: 'Kroatia' },
    { id: 'cu', label: 'Cuba' },
    { id: 'kw', label: 'Kuwait' },
    { id: 'la', label: 'Laos' },
    { id: 'ls', label: 'Lesotho' },
    { id: 'lv', label: 'Latvia' },
    { id: 'lb', label: 'Libanon' },
    { id: 'lr', label: 'Liberia' },
    { id: 'ly', label: 'Libya' },
    { id: 'li', label: 'Liechtenstein' },
    { id: 'lt', label: 'Litauen' },
    { id: 'lu', label: 'Luxembourg' },
    { id: 'mo', label: 'Macao' },
    { id: 'mg', label: 'Madagaskar' },
    { id: 'mw', label: 'Malawi' },
    { id: 'my', label: 'Malaysia' },
    { id: 'mv', label: 'Maldivene' },
    { id: 'ml', label: 'Mali' },
    { id: 'mt', label: 'Malta' },
    { id: 'ma', label: 'Marokko' },
    { id: 'mh', label: 'Marshalløyene' },
    { id: 'mq', label: 'Martinique' },
    { id: 'mr', label: 'Mauritania' },
    { id: 'mu', label: 'Mauritius' },
    { id: 'yt', label: 'Mayotte' },
    { id: 'mx', label: 'Mexico' },
    { id: 'fm', label: 'Mikronesiaføderasjonen' },
    { id: 'mz', label: 'Mosambik' },
    { id: 'md', label: 'Moldova' },
    { id: 'mc', label: 'Monaco' },
    { id: 'mn', label: 'Mongolia' },
    { id: 'me', label: 'Montenegro' },
    { id: 'ms', label: 'Montserrat' },
    { id: 'mm', label: 'Myanmar' },
    { id: 'na', label: 'Namibia' },
    { id: 'nr', label: 'Nauru' },
    { id: 'nl', label: 'Nederland' },
    { id: 'np', label: 'Nepal' },
    { id: 'ni', label: 'Nicaragua' },
    { id: 'ne', label: 'Niger' },
    { id: 'ng', label: 'Nigeria' },
    { id: 'nu', label: 'Niue' },
    { id: 'kp', label: 'Nord-Korea' },
    { id: 'mk', label: 'Makedonia - Republikken' },
    { id: 'mp', label: 'Nord-Marianene' },
    { id: 'nf', label: 'Norfolkøya' },
    { id: 'nc', label: 'Ny-Caledonia' },
    { id: 'nz', label: 'New Zealand' },
    { id: 'om', label: 'Oman' },
    { id: 'at', label: 'Østerrike' },
    { id: 'tl', label: 'Øst-Timor' },
    { id: 'pk', label: 'Pakistan' },
    { id: 'pw', label: 'Palau' },
    { id: 'ps', label: 'Palestina' },
    { id: 'pa', label: 'Panama' },
    { id: 'pg', label: 'Papua Ny-Guinea' },
    { id: 'py', label: 'Paraguay' },
    { id: 'pe', label: 'Peru' },
    { id: 'pn', label: 'Pitcairnøyene' },
    { id: 'pl', label: 'Polen' },
    { id: 'pt', label: 'Portugal' },
    { id: 'pr', label: 'Puerto Rico' },
    { id: 'qa', label: 'Qatar' },
    { id: 're', label: 'Réunion' },
    { id: 'ro', label: 'Romania' },
    { id: 'rw', label: 'Rwanda' },
    { id: 'ru', label: 'Russland' },
    { id: 'bl', label: 'Saint-Barthélemy' },
    { id: 'kn', label: 'Saint Kitts og Nevis' },
    { id: 'lc', label: 'Saint Lucia' },
    { id: 'mf', label: 'Saint-Martin' },
    { id: 'pm', label: 'Saint-Pierre og Miquelon' },
    { id: 'vc', label: 'Saint Vincent og Grenadinene' },
    { id: 'sb', label: 'Salomonøyene' },
    { id: 'ws', label: 'Samoa' },
    { id: 'sh', label: 'St. Helena' },
    { id: 'sm', label: 'San Marino' },
    { id: 'st', label: 'São Tomé og Príncipe' },
    { id: 'sa', label: 'Saudi-Arabia' },
    { id: 'ch', label: 'Sveits' },
    { id: 'sn', label: 'Senegal' },
    { id: 'rs', label: 'Serbia' },
    { id: 'sc', label: 'Seychellene' },
    { id: 'sl', label: 'Sierra Leone' },
    { id: 'sg', label: 'Singapore' },
    { id: 'sx', label: 'Sint Maarten' },
    { id: 'sk', label: 'Slovakia' },
    { id: 'si', label: 'Slovenia' },
    { id: 'so', label: 'Somalia' },
    { id: 'es', label: 'Spania' },
    { id: 'lk', label: 'Sri Lanka' },
    { id: 'gb', label: 'Storbritannia' },
    { id: 'sd', label: 'Sudan' },
    { id: 'sr', label: 'Surinam' },
    { id: 'sz', label: 'Eswatini' },
    { id: 'za', label: 'Sør-Afrika' },
    { id: 'gs', label: 'Sør-Georgia og Sør-Sandwichøyene' },
    { id: 'kr', label: 'Sør-Korea' },
    { id: 'ss', label: 'Sør-Sudan' },
    { id: 'sy', label: 'Syria' },
    { id: 'tj', label: 'Tadsjikistan' },
    { id: 'tw', label: 'Taiwan' },
    { id: 'tz', label: 'Tanzania' },
    { id: 'td', label: 'Tsjad' },
    { id: 'th', label: 'Thailand' },
    { id: 'cz', label: 'Tsjekkia' },
    { id: 'tg', label: 'Togo' },
    { id: 'tk', label: 'Tokelau' },
    { id: 'to', label: 'Tonga' },
    { id: 'tt', label: 'Trinidad og Tobago' },
    { id: 'tn', label: 'Tunisia' },
    { id: 'tr', label: 'Tyrkia' },
    { id: 'tm', label: 'Turkmenistan' },
    { id: 'tc', label: 'Turks- og Caicosøyene' },
    { id: 'tv', label: 'Tuvalu' },
    { id: 'de', label: 'Tyskland' },
    { id: 'ug', label: 'Uganda' },
    { id: 'ua', label: 'Ukraina' },
    { id: 'hu', label: 'Ungarn' },
    { id: 'uy', label: 'Uruguay' },
    { id: 'us', label: 'USA' },
    { id: 'um', label: 'USAs ytre småøyer' },
    { id: 'uz', label: 'Usbekistan' },
    { id: 'vu', label: 'Vanuatu' },
    { id: 'eh', label: 'Vest-Sahara' },
    { id: 'va', label: 'Vatikanstaten' },
    { id: 've', label: 'Venezuela' },
    { id: 'vn', label: 'Vietnam' },
    { id: 'wf', label: 'Wallis og Futuna' },
    { id: 'zm', label: 'Zambia' },
    { id: 'zw', label: 'Zimbabwe' },
];

export const KYC_COUNTRIES_DK: KycCountries[] = [
    { id: 'se', label: 'Sverige' },
    { id: 'no', label: 'Norge' },
    { id: 'dk', label: 'Danmark' },
    { id: 'fi', label: 'Finland' },
    { id: 'af', label: 'Afghanistan' },
    { id: 'al', label: 'Albanien' },
    { id: 'dz', label: 'Algeriet' },
    { id: 'vi', label: 'De Amerikanske Jomfruøer' },
    { id: 'as', label: 'Amerikansk Samoa' },
    { id: 'ad', label: 'Andorra' },
    { id: 'ao', label: 'Angola' },
    { id: 'ai', label: 'Anguilla' },
    { id: 'aq', label: 'Antarktis' },
    { id: 'ag', label: 'Antigua og Barbuda' },
    { id: 'ar', label: 'Argentina' },
    { id: 'am', label: 'Armenien' },
    { id: 'aw', label: 'Aruba' },
    { id: 'au', label: 'Australien' },
    { id: 'az', label: 'Aserbajdsjan' },
    { id: 'bs', label: 'Bahamas' },
    { id: 'bh', label: 'Bahrain' },
    { id: 'bd', label: 'Bangladesh' },
    { id: 'bb', label: 'Barbados' },
    { id: 'by', label: 'Hviderusland' },
    { id: 'be', label: 'Belgien' },
    { id: 'bz', label: 'Belize' },
    { id: 'bj', label: 'Benin' },
    { id: 'bm', label: 'Bermuda' },
    { id: 'bt', label: 'Bhutan' },
    { id: 'bo', label: 'Bolivia' },
    { id: 'bq', label: 'Bonaire, Sint Eustatius og Saba' },
    { id: 'ba', label: 'Bosnien-Hercegovina' },
    { id: 'bw', label: 'Botswana' },
    { id: 'bv', label: 'Bouvetøen' },
    { id: 'br', label: 'Brasilien' },
    { id: 'vg', label: 'De Britiske Jomfruøer' },
    { id: 'io', label: 'Det Britiske Territorium i Det Indiske Ocean' },
    { id: 'bn', label: 'Brunei' },
    { id: 'bg', label: 'Bulgarien' },
    { id: 'bf', label: 'Burkina Faso' },
    { id: 'bi', label: 'Burundi' },
    { id: 'ky', label: 'Caymanøerne' },
    { id: 'cf', label: 'Centralafrikanske Republik' },
    { id: 'cl', label: 'Chile' },
    { id: 'co', label: 'Colombia' },
    { id: 'ck', label: 'Cookøerne' },
    { id: 'cr', label: 'Costa Rica' },
    { id: 'cw', label: 'Curaçao' },
    { id: 'cy', label: 'Cypern' },
    { id: 'dj', label: 'Djibouti' },
    { id: 'dm', label: 'Dominica' },
    { id: 'do', label: 'Dominikanske Republik' },
    { id: 'ec', label: 'Ecuador' },
    { id: 'eg', label: 'Egypten' },
    { id: 'gq', label: 'Ækvatorialguinea' },
    { id: 'ci', label: 'Elfenbenskysten' },
    { id: 'sv', label: 'El Salvador' },
    { id: 'er', label: 'Eritrea' },
    { id: 'ee', label: 'Estland' },
    { id: 'et', label: 'Etiopien' },
    { id: 'fk', label: 'Falklandsøerne' },
    { id: 'fj', label: 'Fiji' },
    { id: 'ph', label: 'Filippinerne' },
    { id: 'ae', label: 'Forenede Arabiske Emirater' },
    { id: 'fr', label: 'Frankrig' },
    { id: 'gf', label: 'Fransk Guyana' },
    { id: 'pf', label: 'Fransk Polynesien' },
    { id: 'tf', label: 'De Franske Sydlige Territorier' },
    { id: 'ga', label: 'Gabon' },
    { id: 'gm', label: 'Gambia' },
    { id: 'ge', label: 'Georgien' },
    { id: 'gh', label: 'Ghana' },
    { id: 'gi', label: 'Gibraltar' },
    { id: 'gr', label: 'Grækenland' },
    { id: 'gd', label: 'Grenada' },
    { id: 'gp', label: 'Guadeloupe' },
    { id: 'gu', label: 'Guam' },
    { id: 'gt', label: 'Guatemala' },
    { id: 'gg', label: 'Guernsey' },
    { id: 'gn', label: 'Guinea' },
    { id: 'gw', label: 'Guinea-Bissau' },
    { id: 'gy', label: 'Guyana' },
    { id: 'ht', label: 'Haiti' },
    { id: 'hm', label: 'Heard- og McDonaldøerne' },
    { id: 'hn', label: 'Honduras' },
    { id: 'hk', label: 'Hongkong' },
    { id: 'in', label: 'Indien' },
    { id: 'id', label: 'Indonesien' },
    { id: 'iq', label: 'Irak' },
    { id: 'ir', label: 'Iran' },
    { id: 'ie', label: 'Irland' },
    { id: 'is', label: 'Island' },
    { id: 'im', label: 'Isle of Man' },
    { id: 'il', label: 'Israel' },
    { id: 'it', label: 'Italien' },
    { id: 'jm', label: 'Jamaica' },
    { id: 'jp', label: 'Japan' },
    { id: 'ye', label: 'Yemen' },
    { id: 'je', label: 'Jersey' },
    { id: 'jo', label: 'Jordan' },
    { id: 'cx', label: 'Juleøen' },
    { id: 'kh', label: 'Cambodja' },
    { id: 'cm', label: 'Cameroun' },
    { id: 'ca', label: 'Canada' },
    { id: 'cv', label: 'Kap Verde' },
    { id: 'kz', label: 'Kasakhstan' },
    { id: 'ke', label: 'Kenya' },
    { id: 'cn', label: 'Kina' },
    { id: 'kg', label: 'Kirgisistan' },
    { id: 'ki', label: 'Kiribati' },
    { id: 'cc', label: 'Cocosøerne' },
    { id: 'km', label: 'Comorerne' },
    { id: 'cg', label: 'Congo' },
    { id: 'cd', label: 'Demokratiske Republik Congo' },
    { id: 'xk', label: 'Kosovo' },
    { id: 'hr', label: 'Kroatien' },
    { id: 'cu', label: 'Cuba' },
    { id: 'kw', label: 'Kuwait' },
    { id: 'la', label: 'Laos' },
    { id: 'ls', label: 'Lesotho' },
    { id: 'lv', label: 'Letland' },
    { id: 'lb', label: 'Libanon' },
    { id: 'lr', label: 'Liberia' },
    { id: 'ly', label: 'Libyen' },
    { id: 'li', label: 'Liechtenstein' },
    { id: 'lt', label: 'Litauen' },
    { id: 'lu', label: 'Luxembourg' },
    { id: 'mo', label: 'Macao' },
    { id: 'mg', label: 'Madagaskar' },
    { id: 'mw', label: 'Malawi' },
    { id: 'my', label: 'Malaysia' },
    { id: 'mv', label: 'Maldiverne' },
    { id: 'ml', label: 'Mali' },
    { id: 'mt', label: 'Malta' },
    { id: 'ma', label: 'Marokko' },
    { id: 'mh', label: 'Marshalløerne' },
    { id: 'mq', label: 'Martinique' },
    { id: 'mr', label: 'Mauretanien' },
    { id: 'mu', label: 'Mauritius' },
    { id: 'yt', label: 'Mayotte' },
    { id: 'mx', label: 'Mexico' },
    { id: 'fm', label: 'Mikronesien' },
    { id: 'mz', label: 'Mozambique' },
    { id: 'md', label: 'Moldova' },
    { id: 'mc', label: 'Monaco' },
    { id: 'mn', label: 'Mongoliet' },
    { id: 'me', label: 'Montenegro' },
    { id: 'ms', label: 'Montserrat' },
    { id: 'mm', label: 'Burma' },
    { id: 'na', label: 'Namibia' },
    { id: 'nr', label: 'Nauru' },
    { id: 'nl', label: 'Holland' },
    { id: 'np', label: 'Nepal' },
    { id: 'ni', label: 'Nicaragua' },
    { id: 'ne', label: 'Niger' },
    { id: 'ng', label: 'Nigeria' },
    { id: 'nu', label: 'Niue' },
    { id: 'kp', label: 'Nordkorea' },
    { id: 'mk', label: 'Nordmakedonien' },
    { id: 'mp', label: 'Nordmarianerne' },
    { id: 'nf', label: 'Norfolkøen' },
    { id: 'nc', label: 'Ny Kaledonien' },
    { id: 'nz', label: 'New Zealand' },
    { id: 'om', label: 'Oman' },
    { id: 'at', label: 'Østrig' },
    { id: 'tl', label: 'Østtimor' },
    { id: 'pk', label: 'Pakistan' },
    { id: 'pw', label: 'Palau' },
    { id: 'ps', label: 'Palæstina' },
    { id: 'pa', label: 'Panama' },
    { id: 'pg', label: 'Papua Ny Guinea' },
    { id: 'py', label: 'Paraguay' },
    { id: 'pe', label: 'Peru' },
    { id: 'pn', label: 'Pitcairn' },
    { id: 'pl', label: 'Polen' },
    { id: 'pt', label: 'Portugal' },
    { id: 'pr', label: 'Puerto Rico' },
    { id: 'qa', label: 'Qatar' },
    { id: 're', label: 'Réunion' },
    { id: 'ro', label: 'Rumænien' },
    { id: 'rw', label: 'Rwanda' },
    { id: 'ru', label: 'Rusland' },
    { id: 'bl', label: 'Saint-Barthélemy' },
    { id: 'kn', label: 'Saint Kitts og Nevis' },
    { id: 'lc', label: 'Saint Lucia' },
    { id: 'mf', label: 'Saint-Martin' },
    { id: 'pm', label: 'Saint-Pierre og Miquelon' },
    { id: 'vc', label: 'Saint Vincent og Grenadinerne' },
    { id: 'sb', label: 'Salomonøerne' },
    { id: 'ws', label: 'Samoa' },
    { id: 'sh', label: 'Sankt Helena' },
    { id: 'sm', label: 'San Marino' },
    { id: 'st', label: 'São Tomé og Príncipe' },
    { id: 'sa', label: 'Saudi-Arabien' },
    { id: 'ch', label: 'Schweiz' },
    { id: 'sn', label: 'Senegal' },
    { id: 'rs', label: 'Serbien' },
    { id: 'sc', label: 'Seychellerne' },
    { id: 'sl', label: 'Sierra Leone' },
    { id: 'sg', label: 'Singapore' },
    { id: 'sx', label: 'Sint Maarten' },
    { id: 'sk', label: 'Slovakiet' },
    { id: 'si', label: 'Slovenien' },
    { id: 'so', label: 'Somalia' },
    { id: 'es', label: 'Spanien' },
    { id: 'lk', label: 'Sri Lanka' },
    { id: 'gb', label: 'Storbritannien' },
    { id: 'sd', label: 'Sudan' },
    { id: 'sr', label: 'Surinam' },
    { id: 'sz', label: 'Swaziland' },
    { id: 'za', label: 'Sydafrika' },
    { id: 'gs', label: 'South Georgia og De Sydlige Sandwichøer' },
    { id: 'kr', label: 'Sydkorea' },
    { id: 'ss', label: 'Sydsudan' },
    { id: 'sy', label: 'Syrien' },
    { id: 'tj', label: 'Tadsjikistan' },
    { id: 'tw', label: 'Taiwan' },
    { id: 'tz', label: 'Tanzania' },
    { id: 'td', label: 'Tchad' },
    { id: 'th', label: 'Thailand' },
    { id: 'cz', label: 'Tjekkiet' },
    { id: 'tg', label: 'Togo' },
    { id: 'tk', label: 'Tokelau' },
    { id: 'to', label: 'Tonga' },
    { id: 'tt', label: 'Trinidad og Tobago' },
    { id: 'tn', label: 'Tunesien' },
    { id: 'tr', label: 'Tyrkiet' },
    { id: 'tm', label: 'Turkmenistan' },
    { id: 'tc', label: 'Turks- og Caicosøerne' },
    { id: 'tv', label: 'Tuvalu' },
    { id: 'de', label: 'Tyskland' },
    { id: 'ug', label: 'Uganda' },
    { id: 'ua', label: 'Ukraine' },
    { id: 'hu', label: 'Ungarn' },
    { id: 'uy', label: 'Uruguay' },
    { id: 'us', label: 'USA' },
    { id: 'um', label: 'Amerikanske Oversøiske Øer' },
    { id: 'uz', label: 'Usbekistan' },
    { id: 'vu', label: 'Vanuatu' },
    { id: 'eh', label: 'Vestsahara' },
    { id: 'va', label: 'Vatikanstaten' },
    { id: 've', label: 'Venezuela' },
    { id: 'vn', label: 'Vietnam' },
    { id: 'wf', label: 'Wallis og Futuna' },
    { id: 'zm', label: 'Zambia' },
    { id: 'zw', label: 'Zimbabwe' },
];
